import React from 'react';

export default function MViewDetailNotifFormListItems({ item, index }) {
  let description = item?.description && JSON.parse(item.description);

  return (
    <tr>
      <td className='has-text-centered middle'>{index + 1}</td>
      <td className='middle'>{description?.name}</td>
      <td className='has-text-centered middle'>{description?.activeClass}</td>
      <td className='has-text-centered middle is-capitalized'>
        {item?.deviceId && item.deviceId.split('_')?.[0]}
      </td>
    </tr>
  );
}
